const CustomButton = (props) => {
  const { text, onClick, type, isBack = false } = props;
  return (
    <button
      type={type === "submit" ? "submit" : "button"}
      onClick={onClick}
      className={
        isBack === true
          ? "linear py-[12px] mt-2 rounded-xl bg-white px-5 text-base font-medium text-black  duration-200 hover:text-white hover:bg-activeOrange"
          : `
                linear py-[12px] mt-2 rounded-xl 
                bg-btn-1 px-5 text-base font-medium 
                text-white transition duration-200 
                hover:bg-btn-2 active:bg-btn-3
                ${props.className}`
      }
    >
      {text}
    </button>
  );
};

export default CustomButton;
